
export const fetchWithCache = async (cacheKey) => {
  const expiryMinutes = 120;
  const cachedData = localStorage.getItem(cacheKey);

  if (cachedData) {
      const { data, timestamp } = JSON.parse(cachedData);
      
      // Check if cached data is still valid
      const now = new Date().getTime();
      if (now - timestamp < expiryMinutes * 60 * 1000) {
          //console.log("Fetched from Cache");
          return data;
      } else {
          console.log("Cache expired, fetching new data...");
      }
  }

  try {
      const response = await fetch("/storeContent.json");
      if (!response.ok) throw new Error("Network response was not ok");
      
      const data = await response.json();
      localStorage.setItem(cacheKey, JSON.stringify({ data, timestamp: new Date().getTime() }));
      return data;
  } catch (error) {
      console.error("Fetch error:", error);
      return cachedData ? JSON.parse(cachedData).data : null; // Return old data if available
  }
};